// __APP_VERSION__/__APP_COMMIT__/__BUILD_DATE__ are injected at build time
// (vite.config.js): version from package.json, commit hash from
// CI_COMMIT_SHORT_SHA or git, build date stamped at build time.
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
export const APP_COMMIT = typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'dev';
export const BUILD_DATE = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : '00000000';
